import { showToast, showErrorToast } from '~/utils/toast-notifications';
import { ActionsCreator } from '@/store/utils';
import { eventManager } from '@/utils/behavior/applicationEvents/event-manager';

export default {
  likePost(context, payload) {
    context.commit('UPDATE_POST_LIKE_OPTIMISTIC', payload);
    this.dispatch('api/likePost', payload.postId)
      .then((res) => {
        context.commit('UPDATE_POST', res.data);
      })
      .catch((err) => {
        context.commit('ROLLBACK_POST_LIKE', payload);
        context.commit('SET_ERROR', err);
      });
  },
  favoritePost(context, payload) {
    this.dispatch('api/favoritePost', payload)
      .then((res) => {
        context.commit('UPDATE_POST', res.data);
      })
      .catch((err) => {
        context.commit('SET_ERROR', err);
      });
  },
  favoriteReply(context, payload) {
    this.dispatch('api/favoritePost', payload)
      .then((res) => {
        context.commit('UPDATE_REPLY', res.data);
      })
      .catch((err) => {
        context.commit('SET_ERROR', err);
      });
  },
  likeReply(context, payload) {
    context.commit('UPDATE_POST_REPLY_LIKE_OPTIMISTIC', payload);
    this.dispatch('api/likePost', payload.replyId)
      .then((res) => {
        context.commit('UPDATE_REPLY', res.data);
      })
      .catch((err) => {
        context.commit('ROLLBACK_POST_REPLY_LIKE', payload);
        context.commit('SET_REPLIES_ERROR', err);
      });
  },
  likeNestedReply(context, payload) {
    context.commit('UPDATE_POST_NESTED_REPLY_LIKE_OPTIMISTIC', payload);
    this.dispatch('api/likePost', payload.nestedReplyId)
      .then((res) => {
        context.commit('UPDATE_NESTED_REPLY', {
          replyId: payload.replyId,
          nestedReply: res.data,
        });
      })
      .catch((err) => {
        context.commit('ROLLBACK_NESTED_REPLY_LIKE', payload);
        context.commit('SET_REPLIES_ERROR', err);
      });
  },
  incrementPostReplyCount(context) {
    context.commit('INCREMENT_POST_REPLYCOUNT');
  },
  incrementNestedReplyReplyCount(context, payload) {
    context.commit('INCREMENT_NESTED_REPLY_REPLYCOUNT', payload);
  },
  incrementReplyReplyCount(context, payload) {
    context.commit('INCREMENT_REPLY_REPLYCOUNT', payload.postId);
  },
  incrementPostRepostCount(context) {
    context.commit('INCREMENT_POST_REPOSTCOUNT');
  },
  incrementReplyRepostCount(context, payload) {
    context.commit('INCREMENT_REPLY_REPOSTCOUNT', payload.postId);
  },
  incrementNestedReplyRepostCount(context, payload) {
    context.commit('INCREMENT_NESTED_REPLY_REPOSTCOUNT', payload);
  },
  getPost(context, payload) {
    context.commit('INIT_PAGE');
    context.commit('SET_POST_LOADING', true);
    return this.dispatch('api/getPostById', payload)
      .then((res) => {
        context.commit('SET_POST', res.data);
      })
      .catch((err) => {
        console.dir(err);
        context.commit('SET_POST_ERROR', err);
      })
      .finally(() => {
        context.commit('SET_POST_LOADING', false);
      });
  },
  setPost(context, post) {
    context.commit('SET_POST', post);
  },
  getReplies(context, payload) {
    context.commit('SET_REPLIES_LOADING', true);
    return this.dispatch('api/getPostReplies', payload)
      .then((res) => {
        context.commit('SET_REPLIES', res.data);
      })
      .catch((err) => {
        console.dir(err);
        context.commit('SET_REPLIES_ERROR', err);
      })
      .finally(() => {
        context.commit('SET_REPLIES_LOADING', false);
      });
  },
  postComment(context, payload) {
    return this.dispatch('api/createPost', payload)
      .then((res) => {
        showToast(window.$nuxt.$t('post_created_ok'));
        context.commit('APPEND_NEW_REPLY', res.data);
        // context.commit('INCREMENT_NEW_REPLY_COUNT');
        eventManager.raiseCreateCommentEvent({
          event_category: 'Interaction article',
          event_action: 'Comment an article',
          post_name: '',
        });
        return res.data;
      })
      .catch((err) => {
        showErrorToast(window.$nuxt.$t('error_occured_message'));
        console.dir(err);
        context.commit('SET_REPLIES_ERROR', err);
      });
  },
  updatePostAfterEdit(context, post) {
    showToast(window.$nuxt.$t('post_updated_ok'));
    context.commit('UPDATE_POST_AFTER_EDIT', post);
  },
  updateReply(context, payload) {
    return this.dispatch('api/updatePost', payload.data)
      .then((res) => {
        showToast(window.$nuxt.$t('post_updated_ok'));
        res.data.updatedDate = payload.data.updatedDate;
        context.commit('UPDATE_REPLY_AFTER_EDIT', {
          postId: payload.postId,
          data: res.data,
        });
      })
      .catch((err) => {
        showErrorToast(window.$nuxt.$t('error_occured_message'));
        context.commit('SET_REPLIES_ERROR', {
          err: err,
          postId: payload.target,
        });
      });
  },
  updateNestedReply(context, payload) {
    return this.dispatch('api/updatePost', payload.data)
      .then((res) => {
        showToast(window.$nuxt.$t('post_updated_ok'));
        res.data.updatedDate = payload.data.updatedDate;
        context.commit('UPDATE_NESTED_REPLY_AFTER_EDIT', {
          replyId: payload.replyId,
          nestedReplyId: payload.nestedReplyId,
          data: res.data,
        });
      })
      .catch((err) => {
        showErrorToast(window.$nuxt.$t('error_occured_message'));
        console.dir(err);
        context.commit('SET_REPLIES_ERROR', {
          err: err,
          postId: payload.data.target,
        });
      });
  },
  getNextReplies(context, payload) {
    context.commit('SET_NEXT_REPLIES_LOADING', true);
    return this.dispatch('api/getPostReplies', payload)
      .then((res) => {
        context.commit('APPEND_REPLIES', res.data);
      })
      .catch((err) => {
        console.error(err);
        context.commit('SET_REPLIES_ERROR', err);
      })
      .finally(() => {
        context.commit('SET_NEXT_REPLIES_LOADING', false);
      });
  },
  getNestedReplies(context, payload) {
    context.commit('SET_REPLIES_LOADING', true);
    this.dispatch('api/getPostReplies', payload)
      .then((res) => {
        if (res.data && res.data.length > 0)
          context.commit('SET_NESTED_REPLIES', {
            postId: payload.postId,
            replies: res.data,
          });
        context.commit('SET_NESTED_REPLY_VIEW_MORE', {
          postId: payload.postId,
          show: res.data.length == payload.params.limit,
        });
      })
      .catch((err) => {
        console.dir(err);
        context.commit('SET_REPLIES_ERROR', err);
      })
      .finally(() => {
        context.commit('SET_REPLIES_LOADING', false);
      });
  },
  getNextNestedReplies(context, payload) {
    this.dispatch('api/getPostReplies', payload)
      .then((res) => {
        if (res.data && res.data.length > 0)
          context.commit('APPEND_NESTED_REPLIES', {
            postId: payload.postId,
            replies: res.data,
          });
        context.commit('SET_NESTED_REPLY_VIEW_MORE', {
          postId: payload.postId,
          show: res.data.length == payload.params.limit,
        });
      })
      .catch((err) => {
        console.dir(err);
        context.commit('SET_REPLIES_ERROR', err);
      });
  },
  appendNewNestedReply(context, payload) {
    const parentReply = context.state.replies.find(
      (r) => r.postId == payload.postId
    );
    if (parentReply.showLoadMore) return;

    context.commit('APPEND_NEW_NESTED_REPLY', payload);
  },
  setRepliesLoading(context, isLoading) {
    context.commit('SET_REPLIES_LOADING', isLoading);
  },
  setIsLoadFinished(context, isLoadFinished) {
    context.commit('SET_IS_LOAD_FINISHED', isLoadFinished);
  },
  getPoll(context, payload) {
    return this.dispatch('api/getPoll', payload)
      .then((res) => {
        context.commit('SET_POLL', { pollId: payload.id, pollData: res.data });
      })
      .catch((err) => {
        context.commit('SET_ERROR', err);
      });
  },
  getPollResults(context, payload) {
    return this.dispatch('api/getPollResults', payload)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        context.commit('SET_ERROR', err);
        return false;
      });
  },
  createPoll(context, payload) {
    return this.dispatch('api/createPoll', payload)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        context.commit('SET_ERROR', err);
      });
  },
  votePoll(context, payload) {
    this.dispatch('api/votePoll', payload)
      .then((res) => {
        context.commit('UPDATE_POLL', res.data);
      })
      .catch((err) => {
        context.commit('SET_ERROR', err);
      });
  },
  deletePostReply(context, payload) {
    return this.dispatch('api/deleteUserPost', { postId: payload.replyId })
      .then((res) => {
        context.commit('DELETE_POST_REPLY_SUCCESS', { replyId: res.data });
        showToast(window.$nuxt.$t('post_deletion_successful'));
      })
      .catch((err) => {
        context.commit('DELETE_POST_REPLY_ERROR', err);
        showErrorToast(window.$nuxt.$t('error_occured_message'));
      });
  },
  deletePostNestedReply(context, payload) {
    return this.dispatch('api/deleteUserPost', {
      postId: payload.nestedReplyId,
    })
      .then((res) => {
        context.commit('DELETE_POST_NESTED_REPLY_SUCCESS', {
          replyId: payload.replyId,
          nestedReplyId: res.data,
        });
        showToast(window.$nuxt.$t('post_deletion_successful'));
      })
      .catch((err) => {
        context.commit('DELETE_POST_NESTED_REPLY_ERROR', err);
        showErrorToast(window.$nuxt.$t('error_occured_message'));
      });
  },
  deletePost(context, payload) {
    return this.dispatch('api/deleteUserPost', { postId: payload.postId })
      .then(() => {
        showToast(window.$nuxt.$t('post_deletion_successful'));
      })
      .catch((err) => {
        showErrorToast(window.$nuxt.$t('error_occured_message'));
        console.error('Error while deleting a post ', err);
      });
  },

  ...ActionsCreator([
    {
      name: 'uploadPostImage',
      mutation: 'UPLOAD_POST_IMAGE',
    },
  ]),
};
